import React from 'react'
import {BrowserRouter as Router, Link, Route, Switch} from 'react-router-dom'
import book from '../../img/1f4d6.png'
import ear from '../../img/1f442.png'
import writinghand from '../../img/270d.png'
import doctor from '../../img/1f468-2695.png'
import Learn from '../Learn/index.js'
import Listen from '../Listen/index.js'
import Quiz from '../Quiz/index.js'
import Refer from '../Help/index.js'
import EmojiIcon from '../EmojiIcon'


class Teacher extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  
  render() {
    const emojiIconWidth = 100;
    let router =
        <div>
          <Switch>
            <Route path='/teacher/listen' component={Listen} />
            <Route path='/teacher/screen' component={Screen} />
            <Route path='/teacher/learn' component={Learn} />
            <Route path='/help' component={Refer} />
            <Route exact path="/teacher" render={() => {
              return(
                  <div className="homeTeacher">
                    <div className=" btn-group-vertical" style={{width: '70%'}}>
                      <Link className="btn btn-lg btn-light home-button" to="/teacher/listen"><EmojiIcon icon={ear} width={emojiIconWidth}/> Listen</Link>
                      <Link className="btn btn-lg btn-light home-button" to="/teacher/screen"><EmojiIcon icon={writinghand} width={emojiIconWidth}/> Question</Link>
                      <Link className="btn btn-lg btn-light home-button" to="/teacher/learn"><EmojiIcon icon={book} width={emojiIconWidth}/> Learn</Link>
                      <Link className="btn btn-lg btn-light home-button" to="/help"><EmojiIcon icon={doctor} width={emojiIconWidth}/> Refer</Link>
                    </div>
                  </div>
              )
            }} />
          </Switch>
        </div>;
    return (
        <Router>
          <div>
            {router}
          </div>
        </Router>
    );
  }
}


export default Teacher;



// WEBPACK FOOTER //
// ./src/components/Teacher/index.js